import { render, staticRenderFns } from "./UserNotification.vue?vue&type=template&id=2e37fc7a&scoped=true&"
import script from "./UserNotification.vue?vue&type=script&lang=js&"
export * from "./UserNotification.vue?vue&type=script&lang=js&"
import style0 from "./UserNotification.vue?vue&type=style&index=0&id=2e37fc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37fc7a",
  null
  
)

export default component.exports